import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearchPlus } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";

const ItemPortfolio = ({ img, title, description, delay = 0, onClick }) => {
    return (
        <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.5, delay: delay * 0.1 }}
            className="group block w-full h-full cursor-pointer"
            onClick={onClick}
        >
            <div className="relative overflow-hidden rounded-2xl glass-card h-full focus-within:ring-2 focus-within:ring-accent-cyan transition-all duration-300 transform group-hover:-translate-y-2 group-hover:shadow-[0_20px_40px_rgba(34,211,238,0.15)] bg-dark-800">
                <div className="relative h-64 w-full overflow-hidden">
                    <img 
                        src={img} 
                        alt={title} 
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                    {/* Overlay gradient en hover */}
                    <div className="absolute inset-0 bg-gradient-to-t from-dark-900 via-dark-900/40 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-300"></div>
                </div>
                
                <div className="absolute bottom-0 left-0 w-full p-6 translate-y-4 group-hover:translate-y-0 transition-transform duration-300 z-10">
                    <p className="text-accent-cyan text-sm font-medium tracking-wider uppercase mb-2 drop-shadow-md">{description}</p>
                    <h5 className="text-white text-xl font-bold mb-0 capitalize drop-shadow-lg">{title}</h5>
                </div>

                {/* Icon wrapper */}
                <div className="absolute top-4 right-4 w-10 h-10 bg-white/10 backdrop-blur-md rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-2 group-hover:translate-y-0 border border-white/20 hover:bg-accent-cyan hover:border-transparent z-20">
                    <FontAwesomeIcon icon={faSearchPlus} className="text-white" />
                </div>
            </div>
        </motion.div>
    );
};

export default ItemPortfolio;
